import { render, staticRenderFns } from "./budgetAddUser.vue?vue&type=template&id=c8763b66&scoped=true"
import script from "./budgetAddUser.vue?vue&type=script&lang=js"
export * from "./budgetAddUser.vue?vue&type=script&lang=js"
import style0 from "./budgetAddUser.vue?vue&type=style&index=0&id=c8763b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8763b66",
  null
  
)

export default component.exports